import {
  AUDIENCE_KINDS,
  type AudienceKindName,
} from "@/lib/channels/audience-kind";

export const channelsCopy = {
  nav: "Мессенджеры",
  title: "Мессенджеры",
  description:
    "Кто пишет боту, какие аудитории видят документы и что отвечают Telegram и MAX.",
  contactsDescription:
    "Кто написал боту из мессенджера. Может не быть сотрудником. Доступ — через аудиторию; привязка к сотруднику только запоминает личность.",
  audiencesDescription:
    "Связывает документы, людей и ботов. Знания, боты, состав и тексты /start, /help — на карточке аудитории.",
  botsDescription:
    "Подключение каналов и прокси, если Bot API недоступен напрямую.",
  connect: "Подключить",
  connectTelegram: "Telegram",
  connectMax: "MAX",
  connectVk: "VK",
  connectWidget: "Виджет на сайте",
  connectSoon: "Скоро",
  connectTitle: "Подключить Telegram-бота",
  connectMaxTitle: "Подключить MAX-бота",
  maxTokenHelp:
    "Токен из MAX для бизнеса после модерации. В интерфейс не возвращается.",
  columnChannel: "Канал",
  channelTelegram: "Telegram",
  tokenLabel: "Токен бота",
  tokenHelp: "Токен из BotFather. В интерфейс не возвращается.",
  submit: "Подключить",
  pending: "Подключаем…",
  connectNext: "Далее",
  connectSkip: "Пропустить",
  connectFinish: "Готово",
  connectFinishPending: "Сохраняем…",
  connectAudienceHelp:
    "Бот отвечает по документам этой аудитории. Можно пропустить и назначить позже.",
  connectCollectionHelp:
    "Выдадим аудитории на чтение. Можно пропустить.",
  connectCollectionNone: "Не выдавать",
  connectAutoJoinLabel: "Включить автоподписку",
  cancel: "Отмена",
  disconnect: "Отключить",
  emptyTitle: "Нет ботов",
  emptyDescription:
    "Подключите токен Telegram (BotFather) или MAX (MAX для бизнеса). Клиенты пишут этому боту.",
  errorTitle: "Мессенджеры",
  denied: "Недостаточно прав",
  missingBot: "Бот не найден",
  saved: "Сохранено",
  save: "Сохранить",
  saving: "Сохраняем…",
  "invalid-token": "Проверьте токен: Telegram его не принял.",
  "missing-app-url":
    "В TELEGRAM_WEBHOOK_URL (или APP_URL) нужен публичный HTTPS, например https://t.pinwiki.ru — не localhost и не http.",
  "telegram-unreachable": "Не удалось связаться с Telegram. Попробуйте ещё раз.",
  "already-here": "Этот бот уже подключён к организации.",
  "already-elsewhere": "Этот бот уже подключён в другом пространстве.",
  "webhook-failed":
    "Telegram не принял webhook. Нужен HTTPS снаружи (TELEGRAM_WEBHOOK_URL), а не запись в BotFather.",
  "invalid-max-token": "Проверьте токен: MAX его не принял.",
  "missing-max-url":
    "В MAX_WEBHOOK_URL (или APP_URL) нужен публичный HTTPS на порту 443, например https://dev.pinwiki.ru — не localhost и не http.",
  "max-unreachable": "Не удалось связаться с MAX. Попробуйте ещё раз.",
  "max-webhook-failed":
    "MAX не принял webhook. Нужен HTTPS на порту 443 (MAX_WEBHOOK_URL или APP_URL), сертификат доверенного УЦ.",
  "invalid-proxy": "Укажите SOCKS: 127.0.0.1:1080 или socks5://хост:порт",
  "invalid-kind": "Выберите тип аудитории",
  "invalid-reply": "Текст ответа не длиннее 2000 символов.",
  proxyTitle: "Доступ к Telegram",
  proxyHelp: "Исходящие запросы к Bot API, если api.telegram.org недоступен напрямую.",
  proxyLabel: "SOCKS-прокси",
  proxyPlaceholder: "127.0.0.1:1080",
  proxyEnable: "Использовать SOCKS-прокси",
  proxySave: "Сохранить прокси",
  proxyPending: "Сохраняем…",
  proxyOk: "Прокси сохранён",
  botsTitle: "Боты",
  repliesTitle: "Ответы бота",
  repliesHelp:
    "Пусто — стандартный текст со списком команд. /docs и /file, /staff — если включены.",
  startReplyLabel: "/start",
  helpReplyLabel: "/help",
  answerStyleLabel: "Манера ответа",
  answerStyleHelp:
    "Как бот говорит: имя, тон, обращение. Не факты. Пусто — обычный стиль. Действует у ботов этой аудитории.",
  audienceKindHelp: "Ярлык. Доступ задаётся выдачей документов этой аудитории.",
  autoJoinLabel: "Автоподписка",
  autoJoinHelp:
    "Кто впервые написал боту этой аудитории — сразу в состав и видит её документы. Можно включить у нескольких аудиторий, если у них разные боты.",
  messengerOptionsTitle: "Команды и источники",
  messengerOptionsHelp:
    "Действует у ботов этой аудитории. Свой текст /start и /help не меняется.",
  allowDocsCommandLabel: "Команда /docs",
  allowFileCommandLabel: "Команда /file",
  allowStaffCommandLabel: "Команда /staff",
  allowStaffCommandHelp:
    "Позвать сотрудника. Нужен хотя бы один ответственный.",
  audienceStaffCallTab: "Позвать сотрудника",
  staffAssigneesTitle: "Ответственные",
  staffAssigneesHelp:
    "Им уйдёт сообщение в Telegram или MAX, если сотрудник писал боту этой аудитории.",
  emptyStaffAssignees: "Нет ответственных",
  emptyStaffAssigneesHelp:
    "Добавьте сотрудника — иначе /staff включить нельзя.",
  addStaffAssignee: "Ответственный",
  alreadyStaffAssignee: "Этот сотрудник уже ответственный",
  "staff-assignees-required": "Сначала укажите ответственных",
  "staff-assignee-last":
    "Пока /staff включена, нужен хотя бы один ответственный",
  showCiteMarksLabel: "Номера источников [n] в ответе",
  "auto-join-taken": "Автоподписка уже включена у другой аудитории.",
  audienceReplyEmpty: "Пусто — стандартный ответ бота.",
  audiencesTitle: "Аудитории",
  createAudience: "Создать аудиторию",
  create: "Создать",
  creating: "Создаём…",
  audienceNameLabel: "Название",
  audienceKindLabel: "Тип",
  audienceBasicsTitle: "Основное",
  emptyAudiencesTitle: "Нет аудиторий",
  emptyAudiencesDescription:
    "Создайте аудиторию, например «Клиенты» или «Сайт», затем выдайте ей документы.",
  contactsTitle: "Внешние пользователи",
  searchBots: "Найти бота",
  searchBotsPlaceholder: "Имя бота",
  searchContacts: "Найти контакт",
  searchPlaceholder: "Имя, Telegram id или аудитория",
  searchAudiences: "Найти аудиторию",
  searchAudiencePlaceholder: "Название, тип или бот",
  filterAccess: "Доступ",
  filterAll: "Все",
  filterNone: "Нет доступа",
  filterEmployee: "Сотрудники",
  filterStaff: "Ждёт сотрудника",
  emptyFilterTitle: "Никого не найдено",
  emptyFilterDescription: "Измените запрос.",
  emptyContactsTitle: "Нет контактов",
  emptyContactsDescription: "Контакт появится, когда кто-то напишет боту.",
  columnName: "Имя",
  columnIdentity: "Идентификатор",
  columnAccess: "Доступ",
  columnKind: "Тип",
  columnContacts: "Контакты",
  columnFiles: "Файлы",
  columnBots: "Боты",
  autoJoinOnShort: "Вкл",
  emptyValue: "—",
  columnAudiences: "Аудитории",
  columnEmployees: "Сотрудники",
  columnBot: "Бот",
  columnDescription: "Описание",
  edit: "Изменить",
  botDescriptionLabel: "Описание",
  botDescriptionHelp: "Для себя: зачем этот бот. В чат не попадает.",
  botCardDescription:
    "Кто писал этому боту и зачем он подключён. Токен здесь не показывается.",
  emptyBotContactsTitle: "Пока никто не писал",
  emptyBotContactsDescription:
    "Контакт появится в этом списке, когда кто-то напишет боту.",
  transcriptsNav: "Переписки ботов",
  transcriptsTitle: "Переписки ботов",
  transcriptsDescription:
    "Вопросы и ответы ботов в Telegram и MAX. Чаты сотрудников здесь не показываются.",
  loggingTitle: "Хранение",
  loggingHelp:
    "Выкл — бот отвечает, текст сразу затирается. Вкл — переписка видна здесь и аудитору.",
  loggingOff: "Не хранить",
  loggingOn: "Хранить",
  transcriptsSortLabel: "Сортировка",
  transcriptsSortActivity: "По активности",
  transcriptsSortName: "По имени",
  transcriptsPoll: "Обновление",
  transcriptsPoll5: "5 с",
  transcriptsPoll30: "30 с",
  transcriptsMaxOpen: "Можно открыть не больше шести чатов.",
  transcriptsPickTitle: "Выберите контакт",
  transcriptsPickDescription:
    "Слева — кто писал боту. Откройте до шести переписок одновременно.",
  transcriptsEmptyChatTitle: "Сообщений нет",
  transcriptsEmptyChatDescription:
    "Переписка появится, если для контакта включено хранение.",
  transcriptsCloseChat: "Закрыть чат",
  transcriptsNoAudience: "Без аудитории",
  searchTranscripts: "Найти контакт",
  searchTranscriptsPlaceholder: "Имя или id",
  emptyTranscriptsTitle: "Нет контактов",
  emptyTranscriptsDescription:
    "Контакт появится, когда кто-то напишет боту в Telegram или MAX.",
  emptyTranscriptTurnsTitle: "Сообщений нет",
  unknownContact: "Контакт удалён",
  "invalid-logging": "Выберите, хранить переписки или нет.",
  "invalid-description": "Описание не длиннее 500 символов.",
  disconnectSelected: "Отключить выбранные",
  disconnectSelectedTitle: "Отключить ботов",
  disconnectSelectedConfirm: "Отключить",
  open: "Открыть",
  addAudience: "Аудитория",
  noAccess: "нет доступа",
  alreadyInAudience: "Контакт уже в этой аудитории",
  missingAudience: "Аудитория не найдена",
  missingContact: "Контакт не найден",
  linkUser: "Сотрудник",
  unlinkUser: "Отвязать",
  linkedMeta: "сотрудник",
  alreadyLinked: "Этот контакт уже привязан к сотруднику",
  missingUser: "Сотрудник не найден",
  "name-taken": "Такое название уже есть",
  "invalid-name": "Укажите название",
  backContacts: "К контактам",
  backAudiences: "К аудиториям",
  contactAccessTitle: "Доступ",
  contactAccessHelp:
    "Аудитории задают документы внешнему собеседнику. Привязка к сотруднику только связывает личность: в боте те же права, что в web.",
  staffRequestTag: "Ждёт сотрудника",
  staffRequestTitle: "Просит сотрудника",
  staffRequestHelp:
    "Написал /staff в боте. Доступ сам не открывается — выдайте аудиторию, если нужно.",
  staffRequestClear: "Снять отметку",
  contactVisibleTitle: "Что видит",
  contactVisibleEmpty: "Документов нет",
  contactVisibleEmptyHelp:
    "Выдайте аудитории доступ к документам или коллекции.",
  contactVisibleFallback: "Чтение",
  contactVisibleColumnDocument: "Документ",
  contactVisibleColumnAccess: "Доступ",
  searchContactVisible: "Поиск документов",
  searchContactVisiblePlaceholder: "Название или доступ",
  contactTranscriptsTitle: "Переписки",
  contactTranscriptsEmpty: "Переписок нет",
  contactTranscriptHidden: "Сообщение скрыто",
  audienceContactsTitle: "Внешние контакты",
  audienceSettingsTab: "Настройки",
  audienceStaffTitle: "Сотрудники, группы и отделы",
  audienceKnowledgeTitle: "Знания",
  addCollection: "Коллекция",
  addDocument: "Файл",
  addPackage: "Пакет",
  emptyAudienceKnowledge: "Знаний пока нет",
  emptyAudienceKnowledgeHelp:
    "Выдайте коллекцию, файл или пакет знаний — бот ответит только по ним.",
  knowledgeKindDocument: "Файл",
  knowledgeKindPackage: "Пакет",
  knowledgeFilesMeta: "Файлов",
  missingPackage: "Пакет не найден или не включён для организации",
  audienceBotsTitle: "Боты",
  addUser: "Сотрудник",
  addGroup: "Группа",
  addDepartment: "Отдел",
  addBot: "Бот",
  emptyAudienceBots: "К аудитории пока не подключён бот.",
  emptyAudienceBotsHelp: "Назначьте Telegram или MAX — у бота может быть только одна аудитория.",
  emptyAudienceStaff: "Сотрудников в составе нет.",
  emptyAudienceStaffHelp: "Добавьте сотрудника, группу или отдел — они увидят документы аудитории и в web, и в боте.",
  botAudienceLabel: "Аудитория",
  botAudienceHelp: "Документы, тексты /start и /help и автоподписка — с этой аудитории.",
  botAudienceNone: "Не назначена",
  addContact: "Контакт",
  emptyAudienceContacts: "В этой аудитории пока никого нет.",
  emptyAudienceContactsHelp: "Добавьте контакт, который уже написал боту.",
} as const;

export const AUDIENCE_KIND_LABELS: Record<AudienceKindName, string> = {
  CLIENT: "Клиенты",
  PARTNER: "Партнёры",
  EMPLOYEE: "Сотрудники",
};

export function audienceKindLabel(kind: string): string {
  return AUDIENCE_KIND_LABELS[kind as AudienceKindName] ?? kind;
}

export function audienceOptionLabel(name: string, kind: string): string {
  return `${name} (${audienceKindLabel(kind).toLowerCase()})`;
}

export type ConnectWizardStep =
  | "token"
  | "audience"
  | "collection"
  | "autoJoin";

export function nextConnectWizardStep(
  step: Exclude<ConnectWizardStep, "autoJoin">,
): ConnectWizardStep {
  if (step === "token") {
    return "audience";
  }
  if (step === "audience") {
    return "collection";
  }
  return "autoJoin";
}

export function connectSetupFields(params: {
  connectionId: string;
  audienceId: string;
  collectionId: string;
  autoJoin: boolean;
  skip: "none" | "audience" | "collection" | "autoJoin";
}): {
  connectionId: string;
  audienceId: string;
  collectionId: string;
  autoJoin: boolean;
} {
  if (params.skip === "audience") {
    return {
      connectionId: params.connectionId,
      audienceId: "",
      collectionId: "",
      autoJoin: false,
    };
  }
  return {
    connectionId: params.connectionId,
    audienceId: params.audienceId,
    collectionId: params.skip === "collection" ? "" : params.collectionId,
    autoJoin: params.skip === "autoJoin" ? false : params.autoJoin,
  };
}

export function channelErrorMessage(code: string): string {
  if (code in channelsCopy) {
    return channelsCopy[code as keyof typeof channelsCopy];
  }
  return channelsCopy.denied;
}

export function formatTelegramWebhookFailure(description?: string): string {
  const detail = description?.trim();
  if (!detail) {
    return channelsCopy["webhook-failed"];
  }
  return `${channelsCopy["webhook-failed"]} (${detail})`;
}

export function telegramBotTitle(username: string): string {
  const name = username.trim().replace(/^@/, "");
  return name ? `@${name}` : "Telegram";
}

export function audienceBotsLabel(usernames: string[]): string {
  if (usernames.length === 0) {
    return channelsCopy.emptyValue;
  }
  return usernames.map(telegramBotTitle).join(", ");
}

export function audienceBotsQuery(
  bots: string | Array<{ username: string }> | undefined,
): string {
  if (!bots) {
    return "";
  }
  if (typeof bots === "string") {
    return bots;
  }
  return bots.map((bot) => telegramBotTitle(bot.username)).join(" ");
}

export function audienceAutoJoinShort(on: boolean): string {
  return on ? channelsCopy.autoJoinOnShort : channelsCopy.emptyValue;
}

export function channelProviderLabel(provider: string): string {
  if (provider === "TELEGRAM") {
    return channelsCopy.channelTelegram;
  }
  if (provider === "MAX") {
    return channelsCopy.connectMax;
  }
  if (provider === "VK") {
    return channelsCopy.connectVk;
  }
  if (provider === "WIDGET") {
    return channelsCopy.connectWidget;
  }
  return provider;
}

export function adminChannelsHref(): string {
  return "/admin/channels";
}

export function adminChannelAudiencesHref(): string {
  return "/admin/channels/audiences";
}

export function adminChannelAudienceHref(
  id: string,
  tab?: "knowledge" | "bots" | "call" | "staff" | "contacts",
): string {
  if (tab === "knowledge") {
    return `/admin/channels/audiences/${id}?tab=knowledge`;
  }
  if (tab === "bots") {
    return `/admin/channels/audiences/${id}?tab=bots`;
  }
  if (tab === "call") {
    return `/admin/channels/audiences/${id}?tab=call`;
  }
  if (tab === "staff") {
    return `/admin/channels/audiences/${id}?tab=staff`;
  }
  if (tab === "contacts") {
    return `/admin/channels/audiences/${id}?tab=contacts`;
  }
  return `/admin/channels/audiences/${id}`;
}

export function audienceDetailTabIndex(
  tab?: string,
): 0 | 1 | 2 | 3 | 4 | 5 {
  if (tab === "knowledge") {
    return 1;
  }
  if (tab === "bots") {
    return 2;
  }
  if (tab === "call") {
    return 3;
  }
  if (tab === "staff") {
    return 4;
  }
  if (tab === "contacts") {
    return 5;
  }
  return 0;
}

export function audienceKnowledgeFilesMeta(count: number): string {
  return `${channelsCopy.knowledgeFilesMeta}: ${count}`;
}

export function adminChannelBotsHref(): string {
  return "/admin/channels/bots";
}

export function adminChannelBotHref(id: string): string {
  return `/admin/channels/bots/${id}`;
}

export function adminChannelContactHref(id: string): string {
  return `/admin/channels/contacts/${id}`;
}

export function adminChannelTranscriptsHref(): string {
  return "/admin/channels/transcripts";
}

export function adminChannelTranscriptHref(id: string): string {
  return `/admin/channels/transcripts/${id}`;
}

export function channelsTabIndex(pathname: string): 0 | 1 | 2 {
  if (pathname.startsWith(adminChannelAudiencesHref())) {
    return 1;
  }
  if (pathname.startsWith(adminChannelBotsHref())) {
    return 2;
  }
  return 0;
}

export function contactIdentityMeta(
  identities: Array<{ provider: string; externalId: string }>,
): string | null {
  if (identities.length === 0) {
    return null;
  }
  return identities
    .map(
      (identity) =>
        `${channelProviderLabel(identity.provider)} · ${identity.externalId}`,
    )
    .join(", ");
}

export function contactIdentityIds(
  identities: Array<{ externalId: string }>,
): string | null {
  if (identities.length === 0) {
    return null;
  }
  return identities.map((identity) => identity.externalId).join(", ");
}

export function contactAudiencesLabel(
  audiences: Array<{ name: string }>,
  linkedUser?: { name: string } | null,
): string {
  if (linkedUser?.name.trim()) {
    return `${channelsCopy.linkedMeta} · ${linkedUser.name.trim()}`;
  }
  const names = audiences.map((item) => item.name.trim()).filter(Boolean);
  return names.length > 0 ? names.join(", ") : channelsCopy.noAccess;
}

export function audienceContactsLabel(count: number): string {
  const n = Math.abs(count) % 100;
  const n1 = n % 10;
  if (n > 10 && n < 20) {
    return `${count} контактов`;
  }
  if (n1 === 1) {
    return `${count} контакт`;
  }
  if (n1 >= 2 && n1 <= 4) {
    return `${count} контакта`;
  }
  return `${count} контактов`;
}

export function filterMessengerContacts<
  T extends {
    displayName: string;
    identities: Array<{ externalId: string }>;
    audiences: Array<{ id?: string; name: string }>;
    linkedUser: { name: string; email: string } | null;
    staffRequested?: boolean;
  },
>(rows: T[], query: string, access = "all"): T[] {
  const needle = query.trim().toLowerCase();
  return rows.filter((row) => {
    if (!matchesContactAccess(row, access)) {
      return false;
    }
    if (!needle) {
      return true;
    }
    if (row.displayName.toLowerCase().includes(needle)) {
      return true;
    }
    if (
      row.identities.some((item) =>
        item.externalId.toLowerCase().includes(needle),
      )
    ) {
      return true;
    }
    if (
      row.audiences.some((item) => item.name.toLowerCase().includes(needle))
    ) {
      return true;
    }
    const linked = row.linkedUser;
    if (!linked) {
      return false;
    }
    return (
      linked.name.toLowerCase().includes(needle) ||
      linked.email.toLowerCase().includes(needle)
    );
  });
}

export function matchesContactAccess<
  T extends {
    audiences: Array<{ id?: string }>;
    linkedUser: { name: string } | null;
    staffRequested?: boolean;
  },
>(row: T, access: string): boolean {
  if (access === "all" || !access) {
    return true;
  }
  if (access === "none") {
    return !row.linkedUser && row.audiences.length === 0;
  }
  if (access === "employee") {
    return Boolean(row.linkedUser);
  }
  if (access === "staff") {
    return Boolean(row.staffRequested);
  }
  return row.audiences.some((item) => item.id === access);
}

export function filterAudiences<
  T extends {
    name: string;
    kind: string;
    bots?: string | Array<{ username: string }>;
  },
>(rows: T[], query: string): T[] {
  const needle = query.trim().toLowerCase();
  if (!needle) {
    return rows;
  }
  return rows.filter((row) => {
    if (row.name.toLowerCase().includes(needle)) {
      return true;
    }
    if (audienceKindLabel(row.kind).toLowerCase().includes(needle)) {
      return true;
    }
    return audienceBotsQuery(row.bots).toLowerCase().includes(needle);
  });
}

export type BotListRow = {
  id: string;
  provider: "TELEGRAM" | "MAX" | string;
  username: string;
  description: string;
  contactCount: number;
  audienceCount: number;
  employeeCount: number;
};

export type BotWriter = {
  connectionId: string;
  externalId: string;
};

export type BotIdentity = {
  externalId: string;
  audienceIds: readonly string[];
  employee: boolean;
};

export type BotActivity = {
  contactCount: number;
  audienceCount: number;
  employeeCount: number;
};

export function emptyBotActivity(): BotActivity {
  return { contactCount: 0, audienceCount: 0, employeeCount: 0 };
}

export function botActivityByConnection(
  writers: readonly BotWriter[],
  identities: readonly BotIdentity[],
): Map<string, BotActivity> {
  const byExternal = new Map(
    identities.map((item) => [item.externalId, item] as const),
  );
  const grouped = new Map<string, Set<string>>();
  for (const writer of writers) {
    const set = grouped.get(writer.connectionId) ?? new Set<string>();
    set.add(writer.externalId);
    grouped.set(writer.connectionId, set);
  }
  const result = new Map<string, BotActivity>();
  for (const [connectionId, externals] of grouped) {
    const audienceIds = new Set<string>();
    let employees = 0;
    for (const externalId of externals) {
      const identity = byExternal.get(externalId);
      if (!identity) {
        continue;
      }
      for (const audienceId of identity.audienceIds) {
        audienceIds.add(audienceId);
      }
      if (identity.employee) {
        employees += 1;
      }
    }
    result.set(connectionId, {
      contactCount: externals.size,
      audienceCount: audienceIds.size,
      employeeCount: employees,
    });
  }
  return result;
}

export function filterMessengerBots<
  T extends { username: string; description?: string },
>(rows: T[], query: string): T[] {
  const needle = query.trim().toLowerCase().replace(/^@/, "");
  if (!needle) {
    return rows;
  }
  return rows.filter((row) => {
    const handle = telegramBotTitle(row.username).toLowerCase().replace(/^@/, "");
    if (handle.includes(needle) || row.username.toLowerCase().includes(needle)) {
      return true;
    }
    return (row.description ?? "").toLowerCase().includes(needle);
  });
}

export const BOT_DESCRIPTION_MAX = 500;

export function normalizeBotDescription(
  raw: string,
): { ok: true; value: string | null } | { ok: false; error: "invalid-description" } {
  const value = raw.trim();
  if (value.length > BOT_DESCRIPTION_MAX) {
    return { ok: false, error: "invalid-description" };
  }
  return { ok: true, value: value.length > 0 ? value : null };
}

export function botDisconnectSelectedMessage(count: number): string {
  if (count === 1) {
    return "Бот перестанет принимать сообщения. Контакты останутся.";
  }
  return `${count} ботов перестанут принимать сообщения. Контакты останутся.`;
}

export const TRANSCRIPT_PAGE_SIZE = 10;
export const TRANSCRIPT_PAGE_SIZES = [10, 20, 50] as const;
export const TRANSCRIPT_PREVIEW_MAX = 80;

export function transcriptPreview(
  question: string,
  max = TRANSCRIPT_PREVIEW_MAX,
): string {
  const text = question.trim().replace(/\s+/g, " ");
  if (text.length <= max) {
    return text;
  }
  return `${text.slice(0, Math.max(max - 1, 1))}…`;
}

export function filterMessengerTranscripts<
  T extends { contactName: string; preview: string },
>(rows: T[], query: string): T[] {
  const needle = query.trim().toLowerCase();
  if (!needle) {
    return rows;
  }
  return rows.filter(
    (row) =>
      row.contactName.toLowerCase().includes(needle) ||
      row.preview.toLowerCase().includes(needle),
  );
}

export type TranscriptMonitorAudience = {
  id: string;
  name: string;
};

export type TranscriptMonitorContact = {
  contactId: string;
  identityId: string;
  displayName: string;
  provider: "TELEGRAM" | "MAX";
  externalId: string;
  loggingEnabled: boolean;
  audiences: TranscriptMonitorAudience[];
  lastPreview: string;
  lastAt: string;
  lastWhen: string;
};

export type TranscriptMonitorSort = "activity" | "name";

export function filterTranscriptMonitorContacts<
  T extends {
    displayName: string;
    externalId: string;
    lastPreview: string;
  },
>(rows: T[], query: string): T[] {
  const needle = query.trim().toLowerCase();
  if (!needle) {
    return rows;
  }
  return rows.filter(
    (row) =>
      row.displayName.toLowerCase().includes(needle) ||
      row.externalId.toLowerCase().includes(needle) ||
      row.lastPreview.toLowerCase().includes(needle),
  );
}

export function sortTranscriptMonitorContacts<
  T extends {
    displayName: string;
    lastAt: string;
  },
>(rows: readonly T[], sort: TranscriptMonitorSort): T[] {
  const copy = [...rows];
  if (sort === "name") {
    copy.sort((left, right) =>
      left.displayName.localeCompare(right.displayName, "ru"),
    );
    return copy;
  }
  copy.sort((left, right) => {
    const leftAt = left.lastAt;
    const rightAt = right.lastAt;
    if (!leftAt && !rightAt) {
      return left.displayName.localeCompare(right.displayName, "ru");
    }
    if (!leftAt) {
      return 1;
    }
    if (!rightAt) {
      return -1;
    }
    return rightAt.localeCompare(leftAt);
  });
  return copy;
}

export function filterContactVisibleDocuments<
  T extends { title: string; access: string },
>(rows: T[], query: string): T[] {
  const needle = query.trim().toLowerCase();
  if (!needle) {
    return rows;
  }
  return rows.filter(
    (row) =>
      row.title.toLowerCase().includes(needle) ||
      row.access.toLowerCase().includes(needle),
  );
}

export function parseMessengerLogging(
  value: FormDataEntryValue | null,
): boolean | null {
  if (value === "true") {
    return true;
  }
  if (value === "false") {
    return false;
  }
  return null;
}

export { AUDIENCE_KINDS };
